export const SET_SHOP_PAGINATION = 'SET_SHOP_PAGINATION'
export const SET_SHOP_PAGINATION_PROPERTY = 'SET_SHOP_PAGINATION_PROPERTY'
export const SET_SHOP_PRODUCTS = 'SET_SHOP_PRODUCTS'
export const SET_SHOP_LOADER = 'SET_SHOP_LOADER'
export const SET_SHOP_LOADER_PROPERTY = 'SET_SHOP_LOADER_PROPERTY'
export const SET_SHOP_CONTROLLER = 'SET_SHOP_CONTROLLER'
